<div class="lrs-dash-collapsed" *ngIf="!expanded">
  <div class="lrs-dash-collapsed-info">
    <span class="lrs-dash-collapsed-title">LRS station</span>
    <span class="lrs-dash-collapsed-station">{{ chainageLabel }}</span>
    <span class="lrs-dash-collapsed-meta" *ngIf="section?.road as road">
      {{ road.lane_count }}-lane · {{ road.width_m | number:'1.0-1' }} m
    </span>
  </div>
  <button type="button" class="lrs-dash-toggle" (click)="toggleExpanded()" title="Expand LRS dashboard">
    Expand dashboard
  </button>
</div>

<div class="lrs-dash" [class.lrs-dash--no-va]="!hasVa" *ngIf="expanded">
  <section class="lrs-dash-card lrs-dash-asset">
    <header>
      <h3>Cross Section — {{ chainageLabel }}</h3>
      <span class="lrs-dash-meta" *ngIf="section?.road as road">{{ road.lane_count }}-lane · {{ road.width_m | number:'1.0-1' }} m</span>
    </header>
    <div class="lrs-dash-chrome">
      <div class="lrs-dash-stepper">
        <button type="button" (click)="stepFirst()" title="First station">⏮</button>
        <button type="button" (click)="stepPrev()" title="Previous">◀</button>
        <label title="Station interval (m)">
          <input type="number" min="5" max="200" step="5" [(ngModel)]="stepIntervalM" /> m
        </label>
        <button type="button" (click)="stepNext()" title="Next">▶</button>
        <button type="button" (click)="stepLast()" title="Last station">⏭</button>
      </div>
      <nav class="lrs-dash-tabs">
        <button
          type="button"
          *ngFor="let t of gradeTabs"
          [class.active]="gradeTab === t.id"
          [title]="t.title"
          (click)="setGradeTab(t.id)"
        >
          {{ t.label }}
        </button>
      </nav>
      <div class="lrs-dash-layers-wrap">
        <button
          type="button"
          class="lrs-dash-layers-btn"
          [class.active]="layersOpen"
          title="Choose what the cross section draws"
          (click)="layersOpen = !layersOpen"
        >
          Show
        </button>
        <div class="lrs-dash-layers-pop" *ngIf="layersOpen">
          <div *ngFor="let g of layerGroups">
            <p>{{ g.label }}</p>
            <label *ngFor="let l of g.items">
              <input type="checkbox" [checked]="layers[l.id]" (change)="toggleLayer(l.id)" />
              {{ l.label }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="lrs-dash-asset-body" [class.has-side]="depthBars.length || miniPathDesign">
      <svg class="lrs-dash-chart" viewBox="0 0 420 150" preserveAspectRatio="xMidYMid meet" role="img" [attr.aria-label]="'Cross section at ' + chainageLabel">
        <text x="210" y="16" text-anchor="middle" class="axis-title">Offset from CL (m) · LHS / RHS</text>
        <line *ngIf="layers.ground" x1="28" y1="62" x2="400" y2="62" class="ground-line" />
        <text *ngIf="layers.ground && section?.ground_elev_m != null" x="32" y="56" class="tick">EGL {{ section?.ground_elev_m | number:'1.1-1' }} m</text>
        <rect
          *ngIf="layers.pavement"
          [attr.x]="pavementLeftX()"
          y="44"
          [attr.width]="pavementRightX() - pavementLeftX()"
          height="36"
          class="pavement"
        />
        <ng-container *ngIf="layers.shoulder">
          <rect
            *ngFor="let sh of roadShoulders"
            [attr.x]="xForOffset(sh.offset_from_m)"
            y="44"
            [attr.width]="xForOffset(sh.offset_to_m) - xForOffset(sh.offset_from_m)"
            height="36"
            class="shoulder"
          />
        </ng-container>
        <ng-container *ngIf="layers.median">
          <rect
            *ngIf="roadMedian as med"
            [attr.x]="xForOffset(med.offset_from_m)"
            y="40"
            [attr.width]="xForOffset(med.offset_to_m) - xForOffset(med.offset_from_m)"
            height="44"
            class="median-fill"
          />
        </ng-container>
        <g *ngIf="layers.pavement">
          <rect
            *ngFor="let ln of roadLanes"
            [attr.x]="xForOffset(ln.offset_from_m)"
            y="44"
            [attr.width]="xForOffset(ln.offset_to_m) - xForOffset(ln.offset_from_m)"
            height="36"
            class="lane"
          />
        </g>
        <line [attr.x1]="xForOffset(0)" y1="28" [attr.x2]="xForOffset(0)" y2="142" class="median" />
        <text [attr.x]="xForOffset(0)" y="26" text-anchor="middle" class="tick">CL</text>
        <line
          *ngIf="section?.road as road"
          [attr.x1]="xForOffset(road.row_left_m)"
          y1="38"
          [attr.x2]="xForOffset(road.row_left_m)"
          y2="88"
          class="row-tick"
        />
        <line
          *ngIf="section?.road as road"
          [attr.x1]="xForOffset(road.row_right_m)"
          y1="38"
          [attr.x2]="xForOffset(road.row_right_m)"
          y2="88"
          class="row-tick"
        />
        <text *ngFor="let tick of offsetTicks" [attr.x]="xForOffset(tick)" y="40" text-anchor="middle" class="tick">
          {{ tick }}
        </text>
        <g *ngFor="let a of visibleAssets">
          <circle
            [attr.cx]="xForOffset(a.offset_m)"
            [attr.cy]="yForDepth(a.depth_m, a.grade)"
            [attr.r]="radiusFor(a)"
            [attr.fill]="colorFor(a)"
          />
          <text
            [attr.x]="xForOffset(a.offset_m) + 10"
            [attr.y]="yForDepth(a.depth_m, a.grade) + 4"
            class="asset-label"
          >
            {{ labelFor(a) }}
          </text>
        </g>
        <text x="10" y="66" class="axis-side">OG</text>
        <text x="10" y="120" class="axis-side">UG</text>
      </svg>
      <div class="lrs-dash-side" *ngIf="depthBars.length || miniPathDesign">
        <p class="axis-title">Utilities depth</p>
        <div class="depth-bars" *ngIf="depthBars.length; else noDepth">
          <div class="depth-row" *ngFor="let b of depthBars">
            <span>{{ b.label }}</span>
            <i [style.width.%]="(b.depth / maxDepth) * 100" [style.background]="b.color"></i>
            <em>{{ b.depth | number:'1.1-1' }} m</em>
          </div>
        </div>
        <ng-template #noDepth><p class="lrs-dash-empty">No UG depths at station.</p></ng-template>
        <svg *ngIf="miniPathDesign" class="mini-va" viewBox="0 0 180 40" aria-label="Mini vertical alignment">
          <path *ngIf="miniPathGround" [attr.d]="miniPathGround" class="va-ground" />
          <path *ngIf="miniPathDesign" [attr.d]="miniPathDesign" class="va-design" />
          <line [attr.x1]="miniX(stationMeasure)" y1="4" [attr.x2]="miniX(stationMeasure)" y2="36" class="va-cursor" />
        </svg>
      </div>
    </div>
    <p class="lrs-dash-empty lrs-dash-empty-inline" *ngIf="!visibleAssets.length">No {{ gradeTab }} assets at this chainage.</p>
  </section>

  <section class="lrs-dash-card lrs-dash-va">
    <header>
      <h3>Vertical Alignment Profile</h3>
      <button type="button" class="lrs-dash-iso-toggle" [class.active]="showIso" (click)="showIso = !showIso">2.5D</button>
    </header>
    <div class="lrs-dash-va-empty" *ngIf="!hasVa; else vaChart">
      <p>{{ profileFailed ? 'Profile unavailable.' : 'No vertical alignment yet.' }}</p>
      <button type="button" class="lrs-dash-cta" (click)="openAlignment()">Edit alignment</button>
    </div>
    <ng-template #vaChart>
      <svg class="lrs-dash-chart va-chart" viewBox="0 0 400 170" role="img" aria-label="Vertical alignment profile">
        <path *ngIf="vaFill" [attr.d]="vaFill" class="va-fill" />
        <path *ngIf="vaPathGround" [attr.d]="vaPathGround" class="va-ground" />
        <path *ngIf="vaPathDesign" [attr.d]="vaPathDesign" class="va-design" />
        <line
          *ngIf="profile"
          [attr.x1]="vaX(stationMeasure)"
          y1="28"
          [attr.x2]="vaX(stationMeasure)"
          y2="150"
          class="va-cursor"
        />
        <g *ngFor="let p of vaPvis">
          <line
            [attr.x1]="vaX(p.t1_measure_m)"
            [attr.y1]="vaY(p.t1_elevation_m)"
            [attr.x2]="vaX(p.t2_measure_m)"
            [attr.y2]="vaY(p.t2_elevation_m)"
            class="va-t-span"
          />
          <circle [attr.cx]="vaX(p.pvi_measure_m)" [attr.cy]="vaY(p.pvi_elevation_m)" r="4.5" class="va-pvi" />
          <circle [attr.cx]="vaX(p.t1_measure_m)" [attr.cy]="vaY(p.t1_elevation_m)" r="2.5" class="va-t" />
          <circle [attr.cx]="vaX(p.t2_measure_m)" [attr.cy]="vaY(p.t2_elevation_m)" r="2.5" class="va-t" />
          <text [attr.x]="vaX(p.pvi_measure_m) + 6" [attr.y]="vaY(p.pvi_elevation_m) - 6" class="va-label">
            {{ p.label || 'VPI' }} K={{ p.k_value | number:'1.0-0' }} L={{ p.curve_length_m | number:'1.0-0' }}
          </text>
        </g>
        <text *ngFor="let t of vaTickMarks" [attr.x]="vaX(t.m)" y="164" text-anchor="middle" class="tick">{{ t.label }}</text>
        <text x="8" y="22" class="axis-title">Elev (m)</text>
      </svg>
    </ng-template>
    <svg *ngIf="showIso" class="lrs-dash-chart iso-chart" viewBox="0 0 240 80" role="img" aria-label="Schematic corridor section">
      <polygon points="40,28 200,18 220,38 60,52" class="iso-pavement" />
      <polygon points="60,52 220,38 220,50 60,64" class="iso-edge" />
      <line x1="120" y1="22" x2="140" y2="56" class="median" />
      <g *ngFor="let a of visibleAssets">
        <ellipse
          [attr.cx]="isoX(a.offset_m, a.depth_m)"
          [attr.cy]="isoY(a.offset_m, a.depth_m, a.grade) - 20"
          [attr.rx]="radiusFor(a) + 4"
          [attr.ry]="radiusFor(a)"
          [attr.fill]="colorFor(a)"
          opacity="0.9"
        />
      </g>
    </svg>
  </section>

  <section class="lrs-dash-card lrs-dash-kpis-card">
    <header>
      <h3>Assets</h3>
      <span class="lrs-dash-meta">{{ total }} total</span>
    </header>
    <div class="lrs-dash-kpis">
      <span>UG {{ ugCount }}</span>
      <span>OG {{ ogCount }}</span>
      <span>XO {{ xoCount }}</span>
    </div>
    <div class="lrs-dash-donut-row">
      <div>
        <svg class="lrs-dash-donut" viewBox="0 0 90 90" *ngIf="typeSlices.length">
          <circle cx="45" cy="45" r="36" class="donut-track" />
          <circle
            *ngFor="let s of typeSlices"
            cx="45"
            cy="45"
            r="36"
            [attr.stroke]="s.color"
            [attr.stroke-dasharray]="s.dash"
            [attr.stroke-dashoffset]="s.offset"
          />
          <text x="45" y="48" text-anchor="middle" class="donut-center">{{ total }}</text>
        </svg>
        <p class="donut-caption">Type</p>
      </div>
      <div>
        <svg class="lrs-dash-donut" viewBox="0 0 90 90" *ngIf="statusSlices.length">
          <circle cx="45" cy="45" r="36" class="donut-track" />
          <circle
            *ngFor="let s of statusSlices"
            cx="45"
            cy="45"
            r="36"
            [attr.stroke]="s.color"
            [attr.stroke-dasharray]="s.dash"
            [attr.stroke-dashoffset]="s.offset"
          />
        </svg>
        <p class="donut-caption">Status</p>
      </div>
    </div>
    <ul class="lrs-dash-legend">
      <li *ngFor="let s of typeLegendSlices">
        <i [style.background]="s.color"></i>{{ s.label }} {{ s.count }}
      </li>
    </ul>
  </section>

  <section class="lrs-dash-card lrs-dash-actions">
    <header>
      <h3>Quick Actions</h3>
      <button
        type="button"
        class="lrs-dash-collapse"
        (click)="toggleExpanded()"
        title="Collapse LRS dashboard"
        aria-label="Collapse LRS dashboard"
      >
        ⌄
      </button>
    </header>
    <div class="lrs-dash-action-grid">
      <button type="button" *ngFor="let a of actions" (click)="runAction(a.id)">{{ a.label }}</button>
    </div>
  </section>
</div>
